<div class="coach-dialog-wrapper">
  <header class="coach-dialog-header">
    <div>
      <p class="coach-dialog-kicker">AI Coach</p>
      <h2 class="coach-dialog-title">Recent model guidance</h2>
    </div>
    <button type="button" class="coach-dialog-close" aria-label="Close AI Coach" (click)="close()">×</button>
  </header>

  <div class="coach-dialog-list" *ngIf="entries.length; else emptyState">
    <article class="coach-dialog-entry" *ngFor="let entry of entries">
      <div class="coach-dialog-entry__top">
        <span class="coach-dialog-model">{{ getModelName(entry) }}</span>
        <span class="coach-dialog-time">{{ formatTimestamp(entry.createdAt) }}</span>
      </div>

      <div class="coach-dialog-summary" *ngIf="getSummary(entry)">
        {{ getSummary(entry) }}
      </div>

      <ul class="coach-dialog-suggestions" *ngIf="entry.suggestions?.length">
        <li *ngFor="let suggestion of entry.suggestions.slice(0, 3)">
          <span class="coach-dialog-suggestion-name">{{ suggestion.modelName || suggestion.modelId }}</span>
          <span class="coach-dialog-suggestion-text">{{ suggestion.reason }}</span>
        </li>
      </ul>
    </article>
  </div>

  <ng-template #emptyState>
    <div class="coach-dialog-empty-state">No requests yet</div>
  </ng-template>
</div>
